// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"e2caa711","885":"998fa6f4"}[chunkId] + ".chunk.js";
};